// src/MiniCategoryModal.jsx
import { useState } from "react";
import {
  collection,
  addDoc,
  updateDoc,
  getDocs,
  query,
  where,
  arrayUnion,
} from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { db } from "./firebase";

export default function MiniCategoryModal({ isOpen, mode, existingCategories, defaultCategory, defaultType, onSave, onClose, refreshBudgets }) {
  const [category, setCategory] = useState(defaultCategory || "");
  const [subcategory, setSubcategory] = useState("");
  const [amount, setAmount] = useState("");
  const [categoryType, setCategoryType] = useState(() => {
    const d = (defaultType || "").toLowerCase();
    if (d) return d;
    const c = (defaultCategory || "").toLowerCase();
    if (c === "income") return "income";
    if (c === "savings") return "savings";
    if (c.includes("not in budget")) return "non-budget";
    return ""; // most expense cats have custom names; leave blank to choose
  });

  const user = getAuth().currentUser;

  const handleSave = async () => {
    if (!subcategory || !category || !user) return;

    if (!categoryType) {
      alert("Please select a category type before saving.");
      return;
    }

    const q = query(
      collection(db, "budgets"),
      where("userId", "==", user.uid),
      where("category", "==", category)
    );
    const snapshot = await getDocs(q);
    const docRef = snapshot.docs[0]?.ref;

    if (mode === "category") {
      if (!snapshot.empty) {
        alert("That category already exists.");
        return;
      }
      await addDoc(collection(db, "budgets"), {
        userId: user.uid,
        category,
        type: categoryType,
        subcategories: [{ name: subcategory, amount: parseFloat(amount) || 0 }],
        amount: 0,
      });
    } else if (mode === "subcategory") {
      if (!docRef) {
        // New category while adding a subcategory
        await addDoc(collection(db, "budgets"), {
          userId: user.uid,
          category,
          type: categoryType,
          subcategories: [{ name: subcategory, amount: parseFloat(amount) || 0 }],
          amount: 0,
        });
      } else {
        await updateDoc(docRef, {
          subcategories: arrayUnion({ name: subcategory, amount: parseFloat(amount) || 0 }),
        });
      }
    }

    onSave(category, subcategory);
  };

  if (!isOpen) return null;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.55)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 20005, // must be > RuleCreator’s 12000
        padding: "16px",
      }}
      onClick={onClose}
    >
      <div
        style={{
          width: "min(420px, 92vw)",
          backgroundColor: "white",
          padding: "1.25rem",
          borderRadius: "10px",
          boxShadow: "0 2px 14px rgba(0,0,0,0.25)",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* keep all your existing modal content below (h3, inputs, buttons, etc.) */}
        <h3 style={{ marginTop: 0 }}>
          {mode === "category" ? "Add New Category" : "Add New Subcategory"}
        </h3>

      {mode === "subcategory" && (
      <>
        <label>Parent Category (you can change or create new)</label><br />
        <input
          list="category-list"
          value={category}
          onChange={(e) => {
            const v = e.target.value;
            setCategory(v);
            // If they pick/type "Savings" and no type chosen yet, default to savings
            if (!categoryType && v.trim().toLowerCase() === "savings") {
              setCategoryType("savings");
            }
          }}
          style={{ width: "100%" }}
        />
        <datalist id="category-list">
          {existingCategories.map((cat, i) => (
            <option key={i} value={cat} />
          ))}
        </datalist>
        <small style={{ color: "#666" }}>
          Leave as-is to add under <strong>{defaultCategory}</strong> — or type a new one.
        </small><br />
      </>
    )}

      <div style={{ marginBottom: "1rem" }}>
        <label style={{ display: "block", fontWeight: "bold" }}>Category Type</label>
        <select
          value={categoryType}
          onChange={(e) => setCategoryType(e.target.value)}
          required
          style={{ padding: "0.5rem", width: "100%", borderRadius: "4px" }}
        >
          <option value="" disabled>Select a type</option>
          <option value="expense">Expense</option>
          <option value="income">Income</option>
          <option value="savings">Savings</option>
          <option value="non-budget">Non-Budget</option>
        </select>
      </div>
      
      {mode === "category" && (
        <>
          <label>New Category Name</label><br />
          <input
            type="text"
            value={category}
            onChange={(e) => {
              const v = e.target.value;
              setCategory(v);
              if (!categoryType && v.trim().toLowerCase() === "savings") {
                setCategoryType("savings");
              }
            }}
            style={{ width: "100%" }}
          />
        </>
      )}

      <label>Subcategory Name</label><br />
      <input type="text" value={subcategory} onChange={(e) => setSubcategory(e.target.value)} style={{ width: "100%" }} /><br />

      <label>Budget Amount</label><br />
      <input type="number" value={amount} onChange={(e) => setAmount(e.target.value)} style={{ width: "100%" }} /><br />

      <div style={{ display: "flex", justifyContent: "space-between", marginTop: "1rem" }}>
        <button onClick={handleSave}>✅ Save</button>
        <button onClick={onClose}>Cancel</button>
      </div>
    </div>
    </div>
  );
}